import React from 'react';

function Footer() {
  return (
    <footer>
      <p>&copy; 2026 Tarkov Hub. Built for the community.</p>
      <p>Not affiliated with or endorsed by Battlestate Games.</p>
    </footer>
  );
}

export default Footer;
